var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"flat":""}},[_vm._l((_vm.itinerary.steps),function(step,index){return _c('ItineraryStepCard',{key:'itinerary-step-' + index,attrs:{"step":step,"firstStep":index === 0},on:{"remove":_vm.emitRemoveStep}})}),_c('ItineraryDestinationCard',{attrs:{"destination":_vm.itinerary.destination}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }